import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-supervisor-overflow',
  templateUrl: './supervisor-overflow.component.html',
  styleUrls: ['./supervisor-overflow.component.css']
})
export class SupervisorOverflowComponent implements OnInit {
  
  //page info
  queueNameOptions: Array<string> = ['None'];
  queueList: Array<any> = [];

  data: Array<any> = [];

  filteredData: Array<any> = [];

  //notification
  lambdaMessage: string = "";
  lambdaError: boolean = false;

  //filters
  lobList: Array<any> = [];
  lobSelect: string = "";
  searchString: string = "";
  
  //datagrid control
  formValid: boolean = true;
  newRow: boolean = false;
  disableLobSelect: boolean = false;
  inputItemsPerPage = 15;
  bluePrint: any = {
    userName: "",
    lob: "",
    overflowQueue: {
      name: "None",
      arn: ""
    }
  };

  constructor(private telecomService: TelecomService) { }

  ngOnInit() {
    this.getData();
    this.getLOBs();
    this.getQueues();
  }

  getData(){
    this.telecomService.getRows(environment.kemperAgentProfileLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.data = data.body.agentProfile;
        for(let x=0; x<this.data.length; x++){
          if(this.data[x].overflowQueue == null){
            this.data[x].overflowQueue = JSON.parse(JSON.stringify(this.bluePrint.overflowQueue));
          }
        }
        console.log("agent data: ", this.data);
        this.applyFilters(this.lobSelect);
      }
      else{
        console.error(data.Error);
      }
    });
  }

  getLOBs(){
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobList = resultData.lobList;
    });
  }

  getQueues(){
    let params = {
      FunctionName: environment.QueueListLambdaName,
      Payload: JSON.stringify({
        operation: 'QueueListAll'
      })
    }
    this.telecomService.callLambda(params, "An error occurred while retrieving queues: ").then((data: any) => {
      if(data.statusCode == 200){
        this.queueList = data.body.queues;
        let temp = [];
        for(let x=0; x<this.queueList.length; x++){
          temp.push(this.queueList[x].Name);
        }
        temp.push('None');
        this.queueNameOptions = JSON.parse(JSON.stringify(temp));
        console.log("queue options: ", this.queueNameOptions);
      }
      else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log("Error: ", data.Error);
      }
    });
  }

  /* compare to input data to detect new user. */
  handleItemChange(evt: any){
    let item = evt.item;
    if(item.overflowQueue.name === 'None'){
      item.overflowQueue = null;
    }
    this.updateAgent(evt.action, item);
  }

  updateAgent(operation: string, userName: string){
    const params = {
      FunctionName: environment.kemperAgentProfileLambdaName,
      Payload: JSON.stringify({
        operation: operation,
        data: userName
      })
    }
    this.telecomService.callLambda(params, "Failed to save changes.").then((data:any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        if(operation == "put"){
          this.lambdaMessage = "Data saved successfully.";
        }else if(operation == "delete"){
          this.lambdaMessage = "Data deleted successfully.";
        }
        this.getData();
      }else{
        this.lambdaMessage = "Failed to save changes.";
        this.lambdaError = true;
        this.applyFilters(this.lobSelect);
      }
    })
  }

  applyFilters(lobSelect: string){
    this.filteredData = [];
    for(let x=0; x < this.data.length; x++){
      if(this.data[x].lob.startsWith(lobSelect)){
        if(this.data[x].userName.includes(this.searchString)){
          this.filteredData.push(this.data[x]);
        }
      }
    }
    this.filteredData.sort((a, b) => {
      if(a.userName < b.userName){
        return -1;
      }else{
        return 1;
      }
    });
    this.filteredData = JSON.parse(JSON.stringify(this.filteredData));
    console.log("filteredData: ", this.filteredData);
  }

  validate(item: any){
    let valid = true;
    this.lambdaError = false;
    this.lambdaMessage = "";
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(item.userName.length < 1){
      valid = false;
      this.lambdaError = true;
      this.lambdaMessage = "Username is required.";
      return valid;
    }

    if(!re.test(item.userName)){
      valid= false;
      this.lambdaError = true;
      this.lambdaMessage = "Invalid Username. Please use agents email."
      return valid;
    }

    if(this.newRow){
      for(let x=0; x< this.data.length; x++){
        if(item.userName == this.data[x].userName){
          valid = false;
          this.lambdaError = true;
          this.lambdaMessage = "Username is already in use."
        }
      }
    }

    if(item.lob.length == ""){
      valid = false;
      this.lambdaError = true;
      this.lambdaMessage = "LOB is required.";
      return valid;
    }

    return valid;
  }

  getQueueName(item: any){
    if(item.overflowQueue.name){
      return item.overflowQueue.name;
    }
    return "None";
  }

  updateMode(gridAction: string){
    this.disableLobSelect = (gridAction == 'add' || gridAction == 'edit');
    if(gridAction == 'add'){
      this.newRow = true;
    }else if(gridAction == 'edit'){
      this.newRow = false;
    }
  }

  setQueueArn(evt: any, item: any){
    if(evt.value != "None"){
      item.overflowQueue.arn = this.queueList[evt.index].Arn;
    }
  }

}
